<!-- ======= Breadcrumbs ======= -->
<!-- <section class="breadcrumbs">
    <div class="container">

        <div class="d-flex justify-content-between align-items-center">
            <h2>Highlights</h2>

            <p-breadcrumb [model]="items"></p-breadcrumb>
            <ol>
                    <li [model]="items"><a href="index.html">Home</a></li>
                    <li>Products </li>
                </ol>
            
        </div>
    </div>
</section> -->
<!-- End Breadcrumbs -->
<!-- <div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="secure-shopping about-fasinating-diamond">
        <p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="carouselResponsiveOptions">
            <ng-template let-banner pTemplate="item">
                <div class="product-item">
                    <div class="product-item-content">
                        <div class="p-mb-1 banner-item-main">
                            <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="container-fluid p-0">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">


                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div> -->

<main id="main">

    <div class="video-banner">
        <div class="video-background">
            <div class="video-foreground">
                <iframe
                    src="https://www.youtube.com/embed/VBNypxBB53s?si=XyUCEhuGMJz_g0G6?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1"
                    frameborder="0" allowfullscreen></iframe>
            </div>
        </div>
    </div>
    <div class="heading">
        <!-- <h1>PUNE WARRIORS | TPL SEASON 2 CHAMPIONS</h1> -->
    </div>

</main><!-- End #main -->

<section id="portfolio" class="portfolio heighlight-section">
    <div class="container" data-aos="fade-up" style="padding-bottom: 300px;">

        <div class="section-title text-center">
            <h2>Seasons
            </h2>
        </div>
        <p-tabView>
            <p-tabPanel header="SEASON 1">
                <div class="seasons-list">
                    <div class="col-lg-4 col-md-6">

                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/ASNE60Pdup0?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Aishwarya" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/Yfo2Jia1cE4?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Niti" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/4etjk-wrhbw?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Rashmi" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>

                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/Mo-rpM65KXE?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Pooja" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/7GUhUjOtwRM?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Sumona" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/tM2BrdrTycE?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Chat Show Tejasswi" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/G-eWfVfIXBA?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 4 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/W0kMrfki0wo?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 2 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/vf2_In2nbNY?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 1 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/bae6itXc_kI?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 3 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/EszniVYCUGI?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 5 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6"><iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/-PePUntv228?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 6 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6"><iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/SAQOOMaO22o?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 7 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe></div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/FKgpOKTAD_A?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 8 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/zJJMa49npa0?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 9 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/t00ih7iRoAk?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 10 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/dufEsEoV2pU?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 11 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/U_ULeyJFYXg?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="EPISODE 13 WITH SCORE" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <iframe width="100%" height="300"
                            src="https://www.youtube.com/embed/FmLDfzav6v0?list=PLqWDDdBkYlEuPNjMmRMLm1_Zy8lDCoS4d"
                            title="Tennis premier league chogada style" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>



                </div>
                <!-- <div class="col-lg-4 col-md-6 portfolio-item filter-web" > -->



            </p-tabPanel>
            <p-tabPanel header="SEASON 2">
                <div class="col-lg-4 col-md-6 portfolio-item filter-app" *ngFor="let item of season2images">
                    <div *ngIf="season2images.length > 0" class="col-md-12 programs-section-headings-main slider p-0">
                        <div class="swiper high-light-slider">
                            <div class="swiper-slide">
                                <div class="heiglght-div card">
                                    <div class="image" (click)="openHightlightImage(item);">
                                        <img src="{{item.src}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <a href="assets/img/heighlight/season2/0E1A0678-min.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A0678-min.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A0678-min.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a> -->
                </div>
                <!-- <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A0742-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A0742-min-scaled.jpg"
                                data-gallery="portfolioGallery" class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A0742-min-scaled.jpg" class="img-fluid"
                                    alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A2216-min.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A2216-min.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A2216-min.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A7297-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A7297-min-scaled.jpg"
                                data-gallery="portfolioGallery" class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A7297-min-scaled.jpg" class="img-fluid"
                                    alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A7394-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A7394-min-scaled.jpg"
                                data-gallery="portfolioGallery" class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A7394-min-scaled.jpg" class="img-fluid"
                                    alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A7410-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A7410-min-scaled.jpg"
                                data-gallery="portfolioGallery" class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A7410-min-scaled.jpg" class="img-fluid"
                                    alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A7513-min.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A7513-min.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A7513-min.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                    <a href="assets/img/heighlight/season2/0E1A7917-min.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/season2/0E1A7917-min.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/season2/0E1A7917-min.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a>
                </div> -->

            </p-tabPanel>
            <p-tabPanel header="SEASON 3">
                <div class="col-lg-4 col-md-6 portfolio-item season-3" *ngFor="let item of season3images">
                    <div *ngIf="season3images.length > 0" class="col-md-12 programs-section-headings-main slider p-0">
                        <div class="swiper high-light-slider">
                            <div class="swiper-slide">
                                <div class="heiglght-div card">
                                    <div class="image" (click)="openHightlightImage(item);">
                                        <img src="{{item.src}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <a href="assets/img/heighlight/4R2A3800-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/4R2A3800-min-scaled.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/4R2A3800-min-scaled.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a> -->
                </div>

                <!-- <div class="col-lg-4 col-md-6 portfolio-item season-3">
                    <a href="assets/img/heighlight/4R2A4343-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/4R2A4343-min-scaled.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/4R2A4343-min-scaled.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-3">
                    <a href="assets/img/heighlight/4R2A8313-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/4R2A8313-min-scaled.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/4R2A8313-min-scaled.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a>
                </div> -->
            </p-tabPanel>
            <p-tabPanel header="SEASON 4">
                <div class="col-lg-4 col-md-6 portfolio-item season-4" *ngFor="let item of season4images">
                    <!-- <a href="assets/img/heighlight/4R2A4348-min-scaled.jpg" data-gallery="portfolioGallery"
                        class="portfolio-lightbox" title="TPL">

                        <div class="portfolio-wrap">
                            <a href="assets/img/heighlight/4R2A4348-min-scaled.jpg" data-gallery="portfolioGallery"
                                class="portfolio-lightbox" title="TPL">
                                <img src="assets/img/heighlight/4R2A4348-min-scaled.jpg" class="img-fluid" alt="">
                            </a>
                        </div>
                    </a> -->
                    <div *ngIf="season4images.length > 0" class="col-md-12 programs-section-headings-main slider p-0">
                        <div class="swiper high-light-slider">
                            <div class="swiper-slide">
                                <div class="heiglght-div card">
                                    <div class="image" (click)="openHightlightImage(item);">
                                        <img src="{{item.src}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </p-tabPanel>
            <p-tabPanel header="SEASON 5">

                <div class="col-lg-4 col-md-6 portfolio-item season-4" *ngFor="let item of season5images">
                    <div *ngIf="season5images.length > 0" class="col-md-12 programs-section-headings-main slider p-0">
                        <div class="swiper high-light-slider">
                            <div class="swiper-slide">
                                <div class="heiglght-div card">
                                    <div class="image"  *ngIf="item.link" >
                                        <a href="{{item.link}}" target="_blank">
                                        <img src="{{item.src}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                        
                                          
                                        </a>   
                                    </div>

                                    <div class="image" (click)="openHightlightImage(item);"  *ngIf="!item.link">
                                        <img src="{{item.src}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- <p:hotkey bind="esc" handler="dlg1.hide(); dlg2.hide();..." /> -->
                </div>
                <!-- <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/2 (1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/2.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/3(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/3.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/4(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/4.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/5.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/6(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/6.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/7(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/7.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/8(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/8.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/9 (1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/9.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/10(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/10.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/11(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/11.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/12(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/12.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/13(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/13.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/14 june.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/14(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/14.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/15(1).png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/15.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/16.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/17.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/18.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/19.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/20.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/21.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/22.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/23.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div>
                <div class="col-lg-4 col-md-6 portfolio-item season-4">
                    <a data-gallery="portfolioGallery" class="portfolio-lightbox">

                        <div class="portfolio-wrap">

                            <img src="assets/img/heighlight/season5/24.png" class="img-fluid" alt="">

                        </div>
                    </a>
                </div> -->


            </p-tabPanel>
        </p-tabView>
    </div>
</section><!-- End Portfolio Section -->

<p-galleria [(value)]="season5images" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-galleria [(value)]="season4images" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-galleria [(value)]="season3images" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-galleria [(value)]="season2images" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>


